import { StorageService } from './storage.service';
import { Options } from 'selenium-webdriver/safari';
import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Session } from '../models/session';
import { LoginObject } from '../models/login-object';
import { ENPOINT } from './endpoint';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { catchError, retry } from 'rxjs/operators';
import { HttpParams, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { User } from '../models/user';

@Injectable()
export class AuthenticationService {
  private basePath = ENPOINT.url;
  constructor(private http: HttpClient,
    private storageService: StorageService,
    private _router: Router) { }

  login(loginObj: LoginObject, idioma: string): Observable<any> {
    let usr = loginObj.username;
    let pass = loginObj.password;

    const options = {
      withCredentials: true,
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      params: new HttpParams()
        .set('user', usr)
        .set('pass', pass)
        .set('idioma', idioma)
    };

    return this.http.get(this.basePath + 'usuarios/login', options).pipe();
  }

  private extractData(res: Response) {
    const body = res.json();
    return body;
  }

  cerrarSesion() {
    const options = {
      withCredentials: true,
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.http.get(this.basePath + 'usuarios/cerrar-sesion', options)
      .pipe();
  }

  cambiarCorreo(userId, newEmail) {
    const options = {
      withCredentials: true,
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set('email', newEmail)
    };
    return this.http.put(this.basePath + 'users/' + userId + '/credentials', options)
      .pipe(
        
      );
  }

  cambiarPassword(userId, newPassword):Observable<any> {
    const options = {
      withCredentials: true,
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set('nuevaPass', newPassword)
    };
    return this.http.put(this.basePath + 'usuarios/password/'+userId, null, options)
      .pipe(
        
      );
  }

  recuperarPassword(username: string, idioma: string): Observable<any> {
    const options = {
      withCredentials: true,
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set('rfc', username)
        .set('idioma', idioma)
    };
    return this.http.get(this.basePath + 'usuarios/recuperar', options)
      .pipe();
  }

  crearRegistro(registro, idioma: string): Observable<any> {
    let user = {
      "nombre": registro.nombreUsuario,
      "rfc": registro.rfcUsuario,
      "password": registro.passUsuario,
      "telefono": registro.telefonoUsuario,
      "direccion": registro.direccionUsuario, 
      "correo": registro.correoUsuario
    }
    let obj = JSON.stringify(user);
    let token = localStorage.getItem('token');
    const options = {
      withCredentials: true,
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      params: new HttpParams()
        .set('idioma', idioma)
      /* params: new HttpParams()
        .set('nombre', registro.nombreUsuario)
        .set('direccion', registro.direccionUsuario)
        .set('telefono', registro.telefonoUsuario)
        .set('rfc', registro.rfcUsuario)
        .set('email', registro.correoUsuario)
        .set('pass', registro.passUsuario)
        .set('conf-pass', registro.cpassUsuario)
        .set('tipo', registro.tipo) */
    };
    return this.http.post(this.basePath + 'usuarios', obj, options)
      .pipe();
  }


}




// WEBPACK FOOTER //
// ./src/app/services/authentication.service.ts